<template>
  <div class="secondOut" :class="{ allComplete: isOrderEnd }">
    <!-- 完成 -->
    <div class="complete" v-if="isOrderEnd || progress > 2 || isAudit">
      <div class="completeContent">
        <div class="completeTitle">
          <h3>{{ isOrderEnd ? "房屋信息" : "完善房屋信息" }}</h3>
        </div>
        <div v-if="(isOrderEnd && progress > 1) || !isOrderEnd">
          <div class="completeItem">
            <p>场地类型</p>
            <span>{{ data.space_type_name }}</span>
          </div>
          <!-- 企业装修存在字段 -->
          <div v-if="data.space_type == 3">
            <div class="completeItem">
              <p>企业名称</p>
              <span v-if="data.info">{{ data.info.company_name }}</span>
            </div>
            <div
              class="completeItem"
              v-if="data.info && data.info.business_license"
            >
              <p>营业执照</p>
              <img
                :src="data.info.business_license[0]"
                alt=""
                @click="comImgView(data.info.business_license)"
              />
              <div @click="comImgView(data.info.business_license)">
                {{ data.info.business_license.length }} 张
              </div>
            </div>
            <div class="completeItem">
              <p>统一社会信用代码</p>
              <span v-if="data.info">{{ data.info.credit_code }}</span>
            </div>
            <div class="completeItem">
              <p>营业执照有效期</p>
              <span v-if="data.info">{{
                data.info.license_validity_time_type == 1
                  ? "长期有效"
                  : data.info.license_validity_time
              }}</span>
            </div>
            <div class="completeItem">
              <p>法定代表人姓名</p>
              <span v-if="data.info">{{ data.info.legal_person }}</span>
            </div>
          </div>
          <div class="completeItem">
            <p>
              {{ data.space_type == 3 ? "法定代表人证件类型" : "证件类型" }}
            </p>
            <span v-if="data.info">{{ data.info.id_card_type_name }}</span>
          </div>
          <div class="completeItem">
            <p>
              {{ data.space_type == 3 ? "法定代表人证件号码" : "证件号码" }}
            </p>
            <span v-if="data.info">{{ data.info.id_card_number }}</span>
          </div>
          <div class="completeItem" v-if="data.info && data.info.id_card_image">
            <p>
              {{ data.space_type == 3 ? "法定代表人证件照片" : "证件照片" }}
            </p>
            <img
              :src="data.info.id_card_image.id_card_image_front[0]"
              alt=""
              @click="
                comImgView(
                  [
                    data.info.id_card_image.id_card_image_front[0],
                    data.info.id_card_image.id_card_image_back[0],
                  ],
                  data.info.id_card_image.id_card_image_front[0]
                )
              "
            />
            <div
              @click="
                comImgView(
                  [
                    data.info.id_card_image.id_card_image_front[0],
                    data.info.id_card_image.id_card_image_back[0],
                  ],
                  data.info.id_card_image.id_card_image_back[0]
                )
              "
            >
              2 张
            </div>
          </div>
          <div class="completeItem">
            <p>
              {{ data.space_type == 3 ? "法定代表人证件有效期" : "证件有效期" }}
            </p>
            <span v-if="data.info">{{
              data.info.id_card_validity_time_type == 1
                ? "长期有效"
                : data.info.id_card_validity_time
            }}</span>
          </div>
          <div class="completeItem">
            <p>装修面积</p>
            <span v-if="data.info">{{ data.info.area }}平</span>
          </div>
          <div class="completeItem">
            <p>装修总价</p>
            <span v-if="data.info">{{ data.total_amount }}元</span>
          </div>
          <div class="completeItem">
            <p>装修地址</p>
            <span>{{ data.province_city_area }}{{ data.address }}</span>
          </div>
          <div class="completeItem">
            <p>房屋类型</p>
            <span v-if="data.info">{{ data.info.house_type_name }}</span>
          </div>
          <div class="completeItem">
            <p>申请数额</p>
            <span>{{ data.amount }}元</span>
          </div>
          <div class="completeItem">
            <p>支付金额</p>
            <span>{{ data.pay_amount }}元</span>
          </div>
          <div class="completeTip">
            <span
              >（中介费{{ data.service_mediation_amount }}元，服务金{{
                data.service_deposit_amount
              }}元）</span
            >
            <img src="./../../../../assets/decoration/order/hsj.png" alt="" />
          </div>
          <div class="completeItem" style="padding-bottom: 24px">
            <p>每期补贴</p>
            <span>{{ data.income_per_period }}元</span>
          </div>
          <div class="completeImg" v-if="data.info">
            <div>
              <p>房屋使用权</p>
              <div>
                <div
                  v-for="(item, index) of data.info.house_using_thumbs"
                  :key="index"
                >
                  <img
                    :src="item"
                    alt=""
                    @click="comImgView(data.info.house_using_thumbs, item)"
                  />
                </div>
                <span class="kb"></span><span class="kb"></span
                ><span class="kb"></span>
              </div>
            </div>
            <div>
              <p>装修现场</p>
              <div>
                <div
                  v-for="(item, index) of data.info.house_scene_thumbs"
                  :key="index"
                >
                  <img
                    :src="item"
                    alt=""
                    @click="comImgView(data.info.house_scene_thumbs, item)"
                  />
                </div>
                <span class="kb"></span><span class="kb"></span
                ><span class="kb"></span>
              </div>
            </div>
            <div>
              <p>门牌号</p>
              <div>
                <div
                  v-for="(item, index) of data.info.house_number_thumbs"
                  :key="index"
                >
                  <img
                    :src="item"
                    alt=""
                    @click="comImgView(data.info.house_number_thumbs, item)"
                  />
                </div>
                <span class="kb"></span><span class="kb"></span
                ><span class="kb"></span>
              </div>
            </div>
            <div>
              <p>装修图纸</p>
              <div>
                <div
                  v-for="(item, index) of data.info.house_drawing_thumbs"
                  :key="index"
                >
                  <img
                    :src="item"
                    v-if="item.indexOf('pdf') == -1"
                    alt=""
                    @click="comImgView(data.info.house_drawing_thumbs, item)"
                  />
                  <img
                    v-else
                    src="./../../../../assets/decoration/order/pdf.png"
                    alt=""
                    @click="comPdfView(item)"
                  />
                </div>
                <span class="kb"></span><span class="kb"></span
                ><span class="kb"></span>
              </div>
            </div>
            <div>
              <p>装修合同</p>
              <div>
                <div
                  v-for="(item, index) of data.info.contract_thumbs"
                  :key="index"
                >
                  <img
                    :src="item"
                    v-if="item.indexOf('pdf') == -1"
                    alt=""
                    @click="comImgView(data.info.contract_thumbs, item)"
                  />
                  <img
                    v-else
                    src="./../../../../assets/decoration/order/pdf.png"
                    alt=""
                    @click="comPdfView(item)"
                  />
                </div>
                <span class="kb"></span><span class="kb"></span
                ><span class="kb"></span>
              </div>
            </div>
          </div>
          <!-- 标签 -->
          <img
            class="bq"
            v-if="isAudit && !isOrderEnd"
            src="./../../../../assets/decoration/order/shz.png"
          />
          <img
            v-if="!isAudit && !isOrderEnd"
            class="bq"
            src="./../../../../assets/decoration/order/ytg.png"
          />
        </div>
        <div v-if="isOrderEnd && progress < 2" class="notdata">
          <img src="./../../../../assets/decoration/order/noData.png" alt="" />
          <p>订单被终止，此项无数据</p>
        </div>
      </div>
    </div>
    <!-- 驳回原因 -->
    <div class="rejectReason" v-if="isReject">
      <div>
        <p ref="detailDom" :class="{ unfold: isUnfold }">
          被驳回：{{ data.judge_remark }}
        </p>
      </div>
      <div class="tipMore" v-if="showDetailBtn">
        <span v-if="!isUnfold" @click="isUnfold = true"
          >展开<img src="./../../../../assets/decoration/moreBottom.png" alt=""
        /></span>
        <span v-if="isUnfold" @click="isUnfold = false"
          >关闭<img src="./../../../../assets/decoration/moreTop.png" alt=""
        /></span>
      </div>
    </div>
    <!-- 未完成 -->
    <div
      class="uncomplete"
      v-if="(!isOrderEnd || isReject) && progress == 2 && !isAudit"
    >
      <!-- 第一部分 -->
      <div class="uncompleteTop">
        <h3>完善房屋信息</h3>
        <div class="placeType">
          <p>场地类型</p>
          <div>
            <div
              :class="{ checkedType: space_type == 4 }"
              @click="placeTypeChange(4)"
            >
              住宅装修
              <img
                src="./../../../../assets/decoration/order/xz.png"
                v-if="space_type == 4"
                alt=""
              />
            </div>
            <div
              :class="{ checkedType: space_type == 3 }"
              @click="placeTypeChange(3)"
            >
              企业装修
              <img
                src="./../../../../assets/decoration/order/xz.png"
                v-if="space_type == 3"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- 企业 -->
        <div v-if="space_type == 3">
          <div class="itemImg yyzz">
            <div>
              <p>营业执照</p>
              <div class="itemImgUplod">
                <van-uploader
                  v-model="fileList4"
                  :max-count="1"
                  accept="image/jpeg, image/jpg, image/png"
                  multiple
                  :after-read="zzafterRead"
                  :before-read="beforeRead"
                  :preview-full-image="false"
                  @delete="deleteFile"
                  @click-preview="clickPreview($event, 4)"
                >
                  <div class="box">
                    <img src="./../../../../assets/decoration/order/yyzz.png" />
                  </div>
                </van-uploader>
                <span>点击上传营业执照</span>
              </div>
            </div>
          </div>
          <div class="item">
            <van-field
              v-model="company_name"
              :border="false"
              label="企业名称"
              placeholder="请输入企业名称"
              @blur="checkIsALLWrite"
            >
            </van-field>
          </div>
          <div class="item">
            <van-field
              v-model="credit_code"
              :border="false"
              label="统一社会信用代码"
              placeholder="请输入统一社会信用代码"
              @blur="checkIsALLWrite"
            >
            </van-field>
          </div>
          <div class="selectItem">
            <div>
              <p>营业执照有效期</p>
              <span
                @click="selectZzType()"
                :style="{
                  color: license_validity_time ? '#333333' : '#CACDE0',
                  fontWeight: license_validity_time ? 'bold' : 'normal',
                }"
                >{{
                  license_validity_time ? license_validity_time : "请选择有效期"
                }}</span
              >
              <img src="./../../../../assets/decoration/order/rl.png" alt="" />
            </div>
          </div>
          <div class="item">
            <div class="itemLable">
              <p>姓名<span>(法定代表人)</span></p>
              <van-field
                v-model="legal_person"
                :border="false"
                placeholder="请输入法定代表人姓名"
                maxlength="20"
                @blur="checkIsALLWrite"
              >
              </van-field>
            </div>
          </div>
        </div>
        <!-- 通用-->
        <div class="selectItem">
          <div>
            <p>证件类型<span v-if="space_type == 3">(法定代表人)</span></p>
            <span
              @click="selectIdType()"
              :style="{
                color: idTypeName ? '#333333' : '#CACDE0',
                fontWeight: idTypeName ? 'bold' : 'normal',
              }"
              v-if="space_type == 3"
              >{{ idTypeName ? idTypeName : "请选择法定代表人证件类型" }}</span
            >
            <span
              @click="selectIdType()"
              :style="{
                color: idTypeName ? '#333333' : '#CACDE0',
                fontWeight: idTypeName ? 'bold' : 'normal',
              }"
              v-else
              >{{ idTypeName ? idTypeName : "请选择证件类型" }}</span
            >
            <img src="./../../../../assets/decoration/order/xia.png" alt="" />
          </div>
        </div>
        <div class="item">
          <div class="itemLable">
            <p>证件号码<span v-if="space_type == 3">(法定代表人)</span></p>
            <van-field
              v-model="id_card_number"
              :border="false"
              :placeholder="
                space_type == 3 ? '请输入法定代表人证件号码' : '请输入证件号码'
              "
              @blur="checkIsALLWrite"
            >
            </van-field>
          </div>
        </div>
        <div class="itemImg">
          <div>
            <p>证件图片<span v-if="space_type == 3">(法定代表人)</span></p>
            <div class="itemImgUplod">
              <van-uploader
                v-model="fileList5"
                :max-count="1"
                accept="image/jpeg, image/jpg, image/png"
                multiple
                :after-read="afterRead"
                :before-read="beforeRead"
                :preview-full-image="false"
                @delete="deleteFile"
                @click-preview="clickPreview($event, 5)"
              >
                <div class="box">
                  <img src="./../../../../assets/decoration/order/rmx.png" />
                </div>
              </van-uploader>
              <span>点击上传人像面</span>
            </div>
            <div class="itemImgUplod">
              <van-uploader
                v-model="fileList6"
                :max-count="1"
                accept="image/jpeg, image/jpg, image/png"
                multiple
                :after-read="afterRead"
                :before-read="beforeRead"
                :preview-full-image="false"
                @delete="deleteFile"
                @click-preview="clickPreview($event, 6)"
              >
                <div class="box">
                  <img src="./../../../../assets/decoration/order/yyzz.png" />
                </div>
              </van-uploader>
              <span>点击上传非人像面</span>
            </div>
          </div>
        </div>
        <div class="selectItem">
          <div>
            <p>证件有效期<span v-if="space_type == 3">(法定代表人)</span></p>
            <span
              @click="selectIdValidityType()"
              :style="{
                color: id_card_validity_time ? '#333333' : '#CACDE0',
                fontWeight: id_card_validity_time ? 'bold' : 'normal',
              }"
              >{{
                id_card_validity_time
                  ? id_card_validity_time
                  : "请选择证件有效期"
              }}</span
            >
            <img src="./../../../../assets/decoration/order/rl.png" alt="" />
          </div>
        </div>
        <div>
          <div class="item">
            <van-field
              v-model="area"
              type="number"
              :border="false"
              label="装修面积"
              placeholder="请输入装修面积"
              @input="formatting($event, 1)"
              @blur="checkIsALLWrite"
            >
              <template #button>
                <span>㎡</span>
              </template>
            </van-field>
          </div>
          <div class="item">
            <van-field
              v-model="total_amount"
              type="number"
              :border="false"
              label="装修总价"
              placeholder="请输入装修总价"
              @input="formatting($event, 2)"
              @blur="checkIsALLWrite"
            >
              <template #button>
                <span>元</span>
              </template>
            </van-field>
          </div>
          <div class="selectItem">
            <div>
              <p>装修地址<span v-if="space_type == 3">(营业执照地址)</span></p>
              <span
                @click="cityPickerShow = true"
                :style="{
                  color: province_city_area ? '#333333' : '#CACDE0',
                  fontWeight: province_city_area ? 'bold' : 'normal',
                }"
                >{{
                  province_city_area ? province_city_area : "请选择装修 省 / 市"
                }}</span
              >
              <img src="./../../../../assets/decoration/order/xia.png" alt="" />
            </div>
          </div>
          <div class="item addressItem">
            <div class="itemLable">
              <p>
                详细地址<span v-if="space_type == 3">(营业执照详细地址)</span>
              </p>
              <van-field
                v-model="address"
                type="textarea"
                :border="false"
                placeholder="请输入详细地址"
                @blur="checkIsALLWrite"
              >
              </van-field>
            </div>
          </div>
          <div class="selectItem">
            <div>
              <p>房屋类型</p>
              <span
                @click="selectRommType()"
                :style="{
                  color: roomTypeName ? '#333333' : '#CACDE0',
                  fontWeight: roomTypeName ? 'bold' : 'normal',
                }"
                >{{ roomTypeName ? roomTypeName : "请选择房屋类型" }}</span
              >
              <img src="./../../../../assets/decoration/order/xia.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 公共 -->
      <div>
        <div class="imgUplod">
          <div class="imgUplodTop">
            <p>房屋使用权</p>
            <span
              >请上传1～9张房产证/房屋购买合同/租房合同，格式jpg，jpeg，png
              ，大小控制在10M内</span
            >
          </div>
          <div class="imgUplodBtm">
            <van-uploader
              v-model="fileList1"
              :max-count="9"
              :max-size="10 * 1024 * 1024"
              accept="image/jpeg, image/jpg, image/png"
              multiple
              :after-read="afterRead"
              :before-read="beforeRead"
              :preview-full-image="false"
              @oversize="onOversize"
              @delete="deleteFile"
              @click-preview="clickPreview($event, 1)"
            >
              <div class="box">
                <img src="./../../../../assets/decoration/order/addImg.png" />
              </div>
            </van-uploader>
          </div>
        </div>
        <div class="imgUplod">
          <div class="imgUplodTop">
            <p>装修现场</p>
            <span
              >请上传1～9张装修现场照片，格式jpg，jpeg，png
              ，大小控制在10M内</span
            >
          </div>
          <div class="imgUplodBtm">
            <van-uploader
              v-model="fileList7"
              :max-count="9"
              accept="image/jpeg, image/jpg, image/png"
              multiple
              :after-read="afterRead"
              :before-read="beforeRead"
              :preview-full-image="false"
              :max-size="10 * 1024 * 1024"
              @oversize="onOversize"
              @delete="deleteFile"
              @click-preview="clickPreview($event, 7)"
            >
              <div class="box">
                <img src="./../../../../assets/decoration/order/addImg.png" />
              </div>
            </van-uploader>
          </div>
        </div>
        <div class="imgUplod">
          <div class="imgUplodTop">
            <p>门牌号</p>
            <span
              >请上传1～5张装修现场照片，格式jpg，jpeg，png
              ，大小控制在10M内</span
            >
          </div>
          <div class="imgUplodBtm">
            <van-uploader
              v-model="fileList8"
              :max-count="5"
              accept="image/jpeg, image/jpg, image/png"
              multiple
              :after-read="afterRead"
              :before-read="beforeRead"
              :preview-full-image="false"
              :max-size="10 * 1024 * 1024"
              @oversize="onOversize"
              @delete="deleteFile"
              @click-preview="clickPreview($event, 8)"
            >
              <div class="box">
                <img src="./../../../../assets/decoration/order/addImg.png" />
              </div>
            </van-uploader>
          </div>
        </div>
        <div class="imgUplod">
          <div class="imgUplodTop">
            <p>装修图纸</p>
            <span
              >请上传1～20张装修图纸，格式jpg，jpeg，png，pdf，大小控制在10M内</span
            >
          </div>
          <div class="imgUplodBtm">
            <van-uploader
              v-model="fileList2"
              :max-count="20"
              accept="image/jpeg, image/jpg, image/png, application/pdf"
              multiple
              :after-read="afterRead"
              :before-read="beforeRead"
              :preview-full-image="false"
              :max-size="10 * 1024 * 1024"
              @oversize="onOversize"
              @delete="deleteFile"
              @click-preview="clickPreview($event, 2)"
            >
              <div class="box">
                <img src="./../../../../assets/decoration/order/addImg.png" />
              </div>
              <template #preview-cover="{ file }">
                <div
                  class="preview-cover"
                  v-if="file.type.indexOf('pdf') != -1"
                >
                  <img
                    src="./../../../../assets/decoration/order/pdf.png"
                    alt=""
                  />
                </div>
              </template>
            </van-uploader>
          </div>
          <div class="pdfTip">
            <span @click="isShowPdfTip = true">上传pdf遇到问题?</span>
          </div>
        </div>
        <div class="imgUplod">
          <div class="imgUplodTop">
            <p>装修合同</p>
            <span
              >请上传1～20张装修照片，格式jpg，jpeg，png，pdf，大小控制在10M内</span
            >
          </div>
          <div class="imgUplodBtm">
            <van-uploader
              v-model="fileList3"
              :max-count="20"
              accept="image/jpeg, image/jpg, image/png, application/pdf"
              multiple
              :after-read="afterRead"
              :before-read="beforeRead"
              :preview-full-image="false"
              :max-size="10 * 1024 * 1024"
              @oversize="onOversize"
              @delete="deleteFile"
              @click-preview="clickPreview($event, 3)"
            >
              <div class="box">
                <img src="./../../../../assets/decoration/order/addImg.png" />
              </div>
              <template #preview-cover="{ file }">
                <div
                  class="preview-cover"
                  v-if="file.type.indexOf('pdf') != -1"
                >
                  <img
                    src="./../../../../assets/decoration/order/pdf.png"
                    alt=""
                  />
                </div>
              </template>
            </van-uploader>
          </div>
          <div class="pdfTip">
            <span @click="isShowPdfTip = true">上传pdf遇到问题?</span>
          </div>
          <div class="item">
            <van-field
              v-model="amount"
              type="digit"
              :border="false"
              label="申请数额"
              placeholder="请输入申请数额"
              @input="calculate"
              @blur="checkIsALLWrite"
            >
              <template #button>
                <span>元</span>
              </template>
            </van-field>
          </div>
          <div class="itemTip" v-if="payMoneyData">
            <div>
              <span>支付金额：</span>
              <p>
                {{ payMoneyData.pay_amount }}元<span
                  >(中介费{{
                    payMoneyData.service_mediation_amount
                  }}元，服务金{{ payMoneyData.service_deposit_amount }}元)</span
                >
              </p>
            </div>
            <div>
              <span>每期补贴：</span>
              <p>{{ payMoneyData.income_per_period }}元</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部提交按钮 -->
      <div class="btmSubmit">
        <div class="btmSubmitTop" @click="isAgree = !isAgree">
          <img
            src="./../../../../assets/decoration/uncheckedF.png"
            v-if="!isAgree"
            alt=""
          />
          <img
            src="./../../../../assets/decoration/checkedF.png"
            v-else
            alt=""
          />
          <p>
            已阅读并同意以下协议
            <span @click.stop="toagreement('ZSBTXZ')"
              >《销巴装饰订单补贴须知》</span
            >
          </p>
        </div>
        <div class="btmSubmitBtm">
          <span @click="save()" v-if="!isReject">保存草稿</span>
          <button
            :class="{ checkedBtn: isAgree && isALLWrite }"
            @click="confirmSubmit()"
          >
            确认并提交
          </button>
        </div>
      </div>
    </div>
    <!-- 类型选择 -->
    <van-action-sheet v-model="pickerShow" :title="pickerTitle">
      <div class="sheetContent">
        <div class="selectType" v-if="pickerType == 1 || pickerType == 2">
          <p
            v-for="(item, index) in pickerList"
            :class="{ check: item.checkd }"
            :key="index"
            @click="onSelect(item.label, item.value, index)"
          >
            {{ item.label }}
          </p>
        </div>
        <div class="selectValidity" v-if="pickerType == 3 || pickerType == 4">
          <div>
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="选择证件有效期"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="validitySelect"
              @cancel="pickerShow = false"
            />
          </div>
          <p><span @click="longTimeValidity()">有效期为长期</span></p>
        </div>
      </div>
    </van-action-sheet>
    <!-- 地址选择 -->
    <van-popup v-model="cityPickerShow" round position="bottom">
      <div @touchmove.stop="">
        <van-cascader
          v-model="cascaderValue"
          title="请选择装修 省 / 市"
          :options="cityOptions"
          :field-names="fieldNames"
          active-color="#5853E9"
          @close="cityPickerShow = false"
          @finish="changeCity"
        />
      </div>
    </van-popup>
    <!-- 图片预览 -->
    <van-image-preview
      v-model="imagePreviewShow"
      :images="images"
      :start-position="activeIndex"
      @change="onChange"
    >
      <template v-slot:index>
        <div class="imagePreview">
          <span @click="imagePreviewShow = false"
            ><van-icon name="cross"
          /></span>
          <span>{{ index }}/{{ images.length }}</span>
          <span @click="deleteImg()"><van-icon name="delete-o" /></span>
        </div>
        <div
          class="imagePreviewTip"
          @click="isShowTip = true"
          :class="{ noShowTip: !isShowTip }"
          v-if="isHavePdf"
        >
          <span><van-icon name="fail" /></span>
          <div v-if="isShowTip">
            <p>
              当前仅为图片查看模式，如需查看已上传的PDF，请返回缩略图点击PDF文件查看。
            </p>
            <div @click.stop="isShowTip = false">
              <van-icon name="cross" />
            </div>
          </div>
        </div>
      </template>
    </van-image-preview>
    <!-- 编辑状态查看pdf -->
    <van-action-sheet v-model="pdfshow">
      <template #description>
        <div class="pdfPopupTop">
          <img
            src="./../../../../assets/decoration/order/coles.png"
            alt=""
            @click="pdfshow = false"
          />
          <span>查看PDF</span>
          <img
            src="./../../../../assets/decoration/order/del.png"
            alt=""
            @click="delPdf()"
          />
        </div>
        <!-- 放大缩小 -->
        <div class="stepper-warpper">
          <van-stepper
            v-model="pdfValue"
            input-width="40px"
            step="0.2"
            :decimal-length="1"
            @change="stepperOnchange"
          />
          <div class="percent">{{ percentValue }}</div>
        </div>
      </template>
      <div style="height: 536px">
        <PdfView
          ref="pdfView"
          :isEdit="true"
          :pdfUrl="pdfUrl"
          :key="pdfUrl"
        ></PdfView>
      </div>
    </van-action-sheet>
    <!-- 查看无法上传pdf提示 -->
    <van-action-sheet v-model="isShowPdfTip" title="上传pdf遇到问题">
      <div class="pdfTipContent">
        <div>
          <p>当前版本过低，无法使用pdf上传功能，请您将APP更新至最新版本。</p>
          <p>更新路径：1.“我的” > 2.“设置” > 3.“版本检测”。</p>
        </div>
        <img src="./../../../../assets/decoration/order/zy.png" alt="" />
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import Upload from "./../../../../providers/upload";
import { ImagePreview } from "vant";
import PdfView from "./../pdfView.vue";
export default {
  props: {
    progress: {
      default: 1,
    },
    id: {
      default: "",
    },
    isOrderEnd: {
      default: false,
    },
  },
  data() {
    return {
      space_type: 4, //场地类型（住宅4；企业3）
      company_name: "", //类型：String  可有字段  备注：企业名称（企业必有）
      credit_code: "", //类型：String  可有字段  备注：统一社会信用代码（企业必有）
      fileList1: [], //房屋使用权
      fileList2: [], //装修图纸
      fileList3: [], //装修合同
      fileList4: [], //营业执照
      fileList5: [], //证件照片人面像
      fileList6: [], //证件照片非人面像
      fileList7: [], //备注：装修现场
      fileList8: [], //门牌号
      isAgree: false,
      pickerShow: false,
      pickerTitle: "",
      pickerList: [],
      pickerType: 1, //1选择身份证，2选择房屋类型
      idTypeList: [
        //法人证件类型
      ],
      roomTypeList: [
        //房屋类型
      ],
      idTypeName: "",
      id_card_type: "", //类型：Number  可有字段  备注：法人证件类型（企业必有）
      id_card_number: "", //类型：String  可有字段  备注：法人证件号码（企业必有）
      legal_person: "", //类型：String  必有字段  备注：法人姓名
      roomTypeName: "",
      house_type: "", //类型：Number  必有字段  备注：房屋类型
      area: "", //类型：Number  必有字段  备注：装饰面积
      total_amount: "", //类型：Number  必有字段  备注：装饰总价
      region: {
        province_id: "", //类型：Object  必有字段  备注：装饰地址
        city_id: "",
      },
      province_city_area: "", //装修地址name
      address: "", //类型：String  必有字段  备注：具体地址
      amount: "", //类型：Number  必有字段  备注：申请数额
      cityPickerShow: false,
      cityOptions: [],
      fieldNames: {
        text: "name",
        value: "code",
        children: "children",
      },
      cascaderValue: "",
      imagePreviewShow: false,
      images: [],
      index: 1,
      activeIndex: 0, //预览图片位置
      activeListIndex: 0, //当前预览文件列表数
      activeFileIndex: 0, //预览图片在文件位置
      isAudit: false,
      isReject: false,
      data: {},
      isUnfold: false,
      showDetailBtn: false,
      detailDom: null,
      isShowTip: false,
      isHavePdf: false,
      pdfshow: false,
      pdfUrl: "",
      pdfValue: 1,
      payMoneyData: null,
      isShowPdfTip: false,
      isALLWrite: false,
      license_validity_time_type: null, //类型：Number  必有字段  备注：营业执照有效期类型，默认 1
      license_validity_time: "", //类型：String  必有字段  备注：营业执照有效时间
      id_card_validity_time_type: null, //类型：String  必有字段  备注：法人证件照有效期类型，默认 1
      id_card_validity_time: "", //类型：String  必有字段  备注：法人证件有效时间
      currentDate: new Date(),
      minDate: new Date(),
      maxDate: new Date(),
    };
  },
  components: { PdfView },
  computed: {
    percentValue() {
      return parseInt(parseFloat(this.pdfValue) * 100) + "%";
    },
  },
  mounted() {
    if (!this.isOrderEnd) {
      this.getAfterNYear();
      this.getCity();
      this.getType();
    }
    this.getOrderData();
    this.detailDom = this.$refs.detailDom;
  },
  methods: {
    stepperOnchange() {
      this.$refs.pdfView.parentStepperOnchange(this.pdfValue);
    },
    // 计算当前时间后20年的日期
    getAfterNYear() {
      let date = new Date();
      let afterDate = `${date.getFullYear() + 20}/${
        date.getMonth() + 1
      }/${date.getDate()}`;
      this.maxDate = new Date(afterDate);
    },
    // 格式化小数点后两位
    formatting(e, type) {
      let value = null;
      if (e.indexOf(".") == -1) {
        value = e;
      } else {
        value = e.substring(0, e.indexOf(".") + 3);
      }
      if (type == 1) {
        // 装修面积
        this.area = value;
      } else if (type == 2) {
        // 装修总价
        this.total_amount = value;
      }
    },
    // 住宅类型切换
    placeTypeChange(type) {
      this.$api
        .post("decoration/member/order/enterprise/info", {
          space_type: type,
        })
        .then((res) => {
          this.space_type = type;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    // 申请数额改变计算
    calculate(e) {
      if (e) {
        this.$api
          .post("decoration/member/order/calculated/amount", {
            order_id: this.id, //订单ID
            amount: e, //申请数额
          })
          .then((res) => {
            this.payMoneyData = res;
          });
      } else {
        this.payMoneyData = null;
      }
    },
    showDetailBtnFun() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.detailDom = this.$refs.detailDom;
          //   console.log(this.detailDom);
          if (this.detailDom) {
            this.showDetailBtn =
              this.detailDom.clientHeight < this.detailDom.scrollHeight;
          }
        }, 100);
      });
    },
    //   获取证件和会员类型
    getType() {
      this.$api.post("decoration/member/order/classify").then((res) => {
        this.idTypeList = res.card_type_list;
        this.roomTypeList = res.house_type_list;
      });
    },
    // 营业执照有效期弹框
    selectZzType() {
      this.pickerTitle = "";
      this.pickerType = 3;
      this.currentDate = new Date(this.license_validity_time);
      this.pickerShow = true;
    },
    // 法人证件有效期弹框
    selectIdValidityType() {
      this.pickerTitle = "";
      this.pickerType = 4;
      this.currentDate = new Date(this.id_card_validity_time);
      this.pickerShow = true;
    },
    //   身份证选择弹框
    selectIdType() {
      this.pickerTitle = "请选择证件类型";
      this.pickerList = this.idTypeList;
      this.pickerType = 1;
      this.pickerShow = true;
    },
    //   房屋类型选择弹框
    selectRommType() {
      this.pickerTitle = "请选择房屋类型";
      this.pickerList = this.roomTypeList;
      this.pickerType = 2;
      this.pickerShow = true;
    },
    // 类型选择
    onSelect(label, value, index) {
      if (this.pickerType == 1) {
        // 证件类型
        this.idTypeList.forEach((item) => {
          item.checkd = false;
        });
        this.idTypeList[index].checkd = true;
        this.idTypeName = label;
        this.id_card_type = value;
      } else if (this.pickerType == 2) {
        // 房屋类型
        this.roomTypeList.forEach((item) => {
          item.checkd = false;
        });
        this.roomTypeList[index].checkd = true;
        this.roomTypeName = label;
        this.house_type = value;
      }
      this.pickerShow = false;
      this.checkIsALLWrite();
    },
    // 有效期选择
    validitySelect(e) {
      let selectDate = new Date(e);
      if (this.pickerType == 3) {
        // 营业执照有效期
        this.license_validity_time = `${selectDate.getFullYear()}/${
          selectDate.getMonth() + 1 > 9
            ? selectDate.getMonth() + 1
            : `0${selectDate.getMonth() + 1}`
        }/${
          selectDate.getDate() > 9
            ? selectDate.getDate()
            : `0${selectDate.getDate()}`
        }`;
        this.license_validity_time_type = 0;
      } else if (this.pickerType == 4) {
        // 法人证件有效期
        this.id_card_validity_time = `${selectDate.getFullYear()}/${
          selectDate.getMonth() + 1 > 9
            ? selectDate.getMonth() + 1
            : `0${selectDate.getMonth() + 1}`
        }/${
          selectDate.getDate() > 9
            ? selectDate.getDate()
            : `0${selectDate.getDate()}`
        }`;
        this.id_card_validity_time_type = 0;
      }
      this.pickerShow = false;
      this.checkIsALLWrite();
    },
    // 设为长期有效期
    longTimeValidity() {
      if (this.pickerType == 3) {
        // 营业执照有效期
        this.license_validity_time = "长期有效";
        this.license_validity_time_type = 1;
      } else if (this.pickerType == 4) {
        // 法人证件有效期
        this.id_card_validity_time = "长期有效";
        this.id_card_validity_time_type = 1;
      }
      this.pickerShow = false;
      this.checkIsALLWrite();
    },
    // 获取城市信息
    getCity() {
      this.$api.get("platformsys/index/areas/list").then((res) => {
        //   因为需要二级联动，而接口返回的是三级，所以需要调整一下数据
        res.list.forEach((item, index) => {
          this.cityOptions.push({
            code: item.code,
            name: item.name,
            children: [],
          });
          item.children.forEach((childerItem, i) => {
            this.cityOptions[index].children.push({
              code: childerItem.code,
              name: childerItem.name,
            });
          });
        });
      });
    },
    // 装修地址选择
    changeCity(value) {
      this.cityPickerShow = false;
      this.province_city_area = "";
      value.selectedOptions.forEach((item, index) => {
        if (index == 0) {
          this.province_city_area = item.name;
          this.region.province_id = item.code;
        } else {
          this.province_city_area = `${this.province_city_area}${item.name}`;
          this.region.city_id = item.code;
        }
      });
      this.checkIsALLWrite();
    },
    // 已完成图片预览
    comImgView(urls, url) {
      let imgs = [];
      let startPosition = 0;
      urls.forEach((item, index) => {
        if (item.indexOf("pdf") == -1) {
          imgs.push(item);
        }
      });
      imgs.forEach((item, index) => {
        if (item == url) {
          startPosition = index;
        }
      });
      ImagePreview({
        images: imgs,
        startPosition: startPosition,
        closeable: true,
        closeIconPosition: "top-left",
      });
    },
    // 已完成pdf预览
    comPdfView(url) {
      this.$router.push({
        path: "/decoration/order/pdfView",
        query: {
          pdfSrc: url,
        },
      });
    },
    // 图片and PDF预览
    clickPreview(file, type) {
      this.isHavePdf = false;
      this.activeListIndex = type;
      this.images = [];
      switch (type) {
        case 1:
          //房屋使用权
          this.fileList1.forEach((item, index) => {
            this.images.push(item.url);
            if (file.url == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 2:
          //装修图纸（存在pdf）
          this.fileList2.forEach((item, index) => {
            if (item.url.substring(item.url.length - 3) != "pdf") {
              this.images.push(item.url);
            } else {
              this.isHavePdf = true;
            }
            if (file.url == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 3:
          //装修合同（存在pdf）
          this.fileList3.forEach((item, index) => {
            if (item.url.substring(item.url.length - 3) != "pdf") {
              this.images.push(item.url);
            } else {
              this.isHavePdf = true;
            }
            if (file.url == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 4:
          //营业执照
          this.fileList4.forEach((item, index) => {
            this.images.push(item.url);
            if (file.url == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 5:
          //证件照片人面像
          this.fileList5.forEach((item, index) => {
            this.images.push(item.url);
            if (file.url == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 6:
          //证件照片非人面像
          this.fileList6.forEach((item, index) => {
            this.images.push(item.url);
            if (file.url == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 7:
          //备注：装修现场
          this.fileList7.forEach((item, index) => {
            this.images.push(item.url);
            if (file.url == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 8:
          //备注：门牌号
          this.fileList8.forEach((item, index) => {
            this.images.push(item.url);
            if (file.url == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        default:
      }
      //   预览pdf
      if (file && file.url.substring(file.url.length - 3) == "pdf") {
        this.pdfUrl = file.url;
        this.pdfshow = true;
      } else {
        // 预览图片
        //   图片赋值选中位置
        this.images.forEach((item, index) => {
          if (file.url == item) {
            this.index = index + 1;
            this.activeIndex = index;
          }
        });
        if (this.images.length < 1) {
          this.imagePreviewShow = false;
        } else {
          this.imagePreviewShow = true;
        }
      }
    },
    onChange(index) {
      this.index = index + 1;
      let activeUrl = this.images[index];
      switch (this.activeListIndex) {
        case 1:
          //房屋使用权
          this.fileList1.forEach((item, index) => {
            if (activeUrl == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 2:
          this.fileList2.forEach((item, index) => {
            if (activeUrl == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 3:
          this.fileList3.forEach((item, index) => {
            if (activeUrl == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 4:
          //营业执照
          this.fileList4.forEach((item, index) => {
            if (activeUrl == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 5:
          //证件照片人面像
          this.fileList5.forEach((item, index) => {
            if (activeUrl == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 6:
          //证件照片非人面像
          this.fileList6.forEach((item, index) => {
            if (activeUrl == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 7:
          //备注：装修现场
          this.fileList7.forEach((item, index) => {
            if (activeUrl == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        case 8:
          //备注：门牌号
          this.fileList8.forEach((item, index) => {
            if (activeUrl == item.url) {
              this.activeFileIndex = index;
            }
          });
          break;
        default:
      }
    },
    // 删除图片
    deleteImg() {
      switch (this.activeListIndex) {
        case 1:
          //房屋使用权
          this.fileList1.splice(this.activeFileIndex, 1);
          break;
        case 2:
          //装修图纸
          this.fileList2.splice(this.activeFileIndex, 1);
          break;
        case 3:
          //装修合同
          this.fileList3.splice(this.activeFileIndex, 1);
          break;
        case 4:
          //营业执照
          this.fileList4.splice(this.activeFileIndex, 1);
          break;
        case 5:
          //证件照片人面像
          this.fileList5.splice(this.activeFileIndex, 1);
          break;
        case 6:
          //证件照片非人面像
          this.fileList6.splice(this.activeFileIndex, 1);
          break;
        case 7:
          //备注：装修现场
          this.fileList7.splice(this.activeFileIndex, 1);
          break;
        case 8:
          //备注：门牌号
          this.fileList8.splice(this.activeFileIndex, 1);
          break;
        default:
      }
      this.activeIndex = this.index - 1;
      if (this.activeIndex > 0) {
        this.activeIndex -= 1;
        this.index -= 1;
      } else {
        this.activeIndex = 0;
      }
      if (this.images[this.activeIndex + 1]) {
        this.clickPreview(
          { url: this.images[this.activeIndex + 1] },
          this.activeListIndex
        );
      } else {
        this.clickPreview("", this.activeListIndex);
      }
      this.checkIsALLWrite();
    },
    // 删除pdf
    delPdf() {
      switch (this.activeListIndex) {
        case 2:
          //装修图纸
          this.fileList2.forEach((item, index) => {
            if (item.url == this.pdfUrl) {
              this.fileList2.splice(index, 1);
            }
          });
          break;
        case 3:
          //装修合同
          this.fileList3.forEach((item, index) => {
            if (item.url == this.pdfUrl) {
              this.fileList3.splice(index, 1);
            }
          });
          break;
        default:
      }
      this.pdfshow = false;
      this.checkIsALLWrite();
    },
    beforeRead(file) {
      if (file.size == 0 || JSON.stringify(file.file) == "{}") {
        //解决部分机型取消上传还是添加空白图片
        return false;
      } else {
        return true;
      }
    },
    afterRead(file, type) {
      if (Array.isArray(file)) {
        // 多选
        file.forEach((item) => {
          this.imgUpload(item, type);
        });
      } else {
        // 单选
        this.imgUpload(file, type);
      }
      this.checkIsALLWrite();
    },
    // 营业执照上传
    zzafterRead(file) {
      this.afterRead(file, "zz");
    },
    deleteFile() {
      this.checkIsALLWrite();
    },
    onOversize(file) {
      this.$toast("上传文件大小请控制在10M内");
    },
    // 图片上传
    imgUpload(file, type) {
      file.status = "uploading";
      file.message = "上传中...";
      if (file.file.type.indexOf("pdf") == -1) {
        Upload.upload(file.file, ["others"])
          .then((res) => {
            file.status = "";
            file.message = "";
            file.url = res;
            // 如果营业执照上传成功，调取接口
            if (type == "zz") {
              this.getZz(res);
            }
          })
          .catch((res) => {
            file.status = "failed";
            file.message = "失败";
          });
      } else {
        // pdf上传
        Upload.upload(file.file, ["others"], false, ".pdf")
          .then((res) => {
            file.status = "";
            file.message = "";
            file.url = res;
          })
          .catch((res) => {
            file.status = "failed";
            file.message = "失败";
          });
      }
    },
    // 查询营业执照获取信息
    getZz(url) {
      this.$api
        .post("decoration/member/order/license/info", { pic_url: url })
        .then((res) => {
          this.legal_person = res.legal_person;
          this.credit_code = res.credit_code;
          this.company_name = res.company_name;
        });
    },
    // 获取订单信息
    getOrderData() {
      this.$api
        .post("decoration/member/order/info", {
          order_id: this.id,
          scene: "supplement",
        })
        .then((res) => {
          if (this.isOrderEnd || this.progress > 2) {
            this.data = res;
            return;
          }
          //   判断当前状态
          this.isAudit = false;
          this.isReject = false;
          if (res.status == 110 || res.status == 120) {
            //   审核中
            this.isAudit = true;
            this.data = res;
            return;
          } else if (res.status == -120 || res.status == -130) {
            //   已驳回
            this.isReject = true;
            this.data = res;
            this.showDetailBtnFun();
          }
          // 赋值
          this.space_type = res.space_type == 0 ? 4 : res.space_type;
          this.region.province_id = res.province_id;
          this.region.city_id = res.city_id;
          this.total_amount = res.total_amount;
          this.province_city_area = res.province_city_area;
          this.address = res.address;
          this.amount = res.amount;
          this.calculate(this.amount);
          if (res.info) {
            this.company_name = res.info.company_name;
            this.credit_code = res.info.credit_code;
            this.id_card_type = res.info.id_card_type;
            this.idTypeName = res.info.id_card_type_name;
            this.id_card_number = res.info.id_card_number;
            this.legal_person = res.info.legal_person;
            this.area = res.info.area;
            this.house_type = res.info.house_type;
            this.roomTypeName = res.info.house_type_name;
            // 证件有效期
            if (res.info.license_validity_time_type === 1) {
              this.license_validity_time = "长期有效";
            } else if (res.info.license_validity_time_type === 0) {
              this.license_validity_time =
                res.info.license_validity_time.replace(/-/g, "/");
            }
            this.license_validity_time_type =
              res.info.license_validity_time_type;
            if (res.info.id_card_validity_time_type === 1) {
              this.id_card_validity_time = "长期有效";
            } else if (res.info.id_card_validity_time_type === 0) {
              this.id_card_validity_time =
                res.info.id_card_validity_time.replace(/-/g, "/");
            }
            this.id_card_validity_time_type =
              res.info.id_card_validity_time_type;
            //房屋使用权
            res.info.house_using_thumbs.forEach((item, index) => {
              this.fileList1.push({ url: item });
            });
            //装修图纸
            res.info.house_drawing_thumbs.forEach((item, index) => {
              this.fileList2.push({
                url: item,
                file: new File([], "文件名称", {
                  type: item.indexOf("pdf") != -1 ? "application/pdf" : "image",
                }),
              });
            });
            //装修合同
            res.info.contract_thumbs.forEach((item, index) => {
              this.fileList3.push({
                url: item,
                file: new File([], "文件名称", {
                  type: item.indexOf("pdf") != -1 ? "application/pdf" : "image",
                }),
              });
            });
            //营业执照
            if (res.info.business_license) {
              res.info.business_license.forEach((item, index) => {
                this.fileList4.push({ url: item });
              });
            }
            if (res.info.id_card_image) {
              //证件照片人面像
              res.info.id_card_image.id_card_image_front.forEach(
                (item, index) => {
                  this.fileList5.push({ url: item });
                }
              );
              //证件照片非人面像
              res.info.id_card_image.id_card_image_back.forEach(
                (item, index) => {
                  this.fileList6.push({ url: item });
                }
              );
            }
            //装修现场
            res.info.house_scene_thumbs.forEach((item, index) => {
              this.fileList7.push({ url: item });
            });
            //门牌号
            res.info.house_number_thumbs.forEach((item, index) => {
              this.fileList8.push({ url: item });
            });
          }
          this.idTypeList.forEach((item, index) => {
            if (item.value == this.id_card_type) {
              item.checkd = true;
            }
          });
          this.roomTypeList.forEach((item, index) => {
            if (item.value == this.house_type) {
              item.checkd = true;
            }
          });
          this.checkIsALLWrite();
        });
    },
    // 检查是否填写完整
    checkIsALLWrite() {
      // 住宅
      if (this.space_type == 4) {
        if (
          this.area &&
          this.total_amount &&
          this.province_city_area &&
          this.address &&
          this.house_type &&
          this.fileList1.length > 0 &&
          this.fileList7.length > 0 &&
          this.fileList2.length > 0 &&
          this.fileList3.length > 0 &&
          this.amount &&
          this.id_card_type &&
          this.id_card_number &&
          this.id_card_validity_time &&
          this.fileList5.length > 0 &&
          this.fileList6.length > 0 &&
          this.fileList8.length > 0
        ) {
          this.isALLWrite = true;
        } else {
          this.isALLWrite = false;
        }
      } else {
        // 企业
        if (
          this.company_name &&
          this.credit_code &&
          this.legal_person &&
          this.id_card_type &&
          this.id_card_number &&
          this.area &&
          this.total_amount &&
          this.province_city_area &&
          this.address &&
          this.house_type &&
          this.fileList1.length > 0 &&
          this.fileList7.length > 0 &&
          this.fileList2.length > 0 &&
          this.fileList3.length > 0 &&
          this.fileList4.length > 0 &&
          this.fileList5.length > 0 &&
          this.fileList6.length > 0 &&
          this.fileList8.length > 0 &&
          this.amount &&
          this.license_validity_time &&
          this.id_card_validity_time
        ) {
          this.isALLWrite = true;
        } else {
          this.isALLWrite = false;
        }
      }
    },
    // 查看协议
    toagreement(number) {
      this.save(3);
      this.$router.push({
        path: "/cms-agreement/detail",
        query: {
          entranceChannel: 1,
          number: number,
          isApp: 1,
        },
      });
    },
    // 保存草稿箱
    save(type = 1) {
      this.submit("decoration/member/order/draft", type);
    },
    confirmSubmit() {
      if (!this.isALLWrite) {
        this.$toast("请将所有信息填写完整");
        return;
      } else if (!this.isAgree) {
        this.$toast("请先勾选协议");
        return;
      }
      this.$api.get("decoration/basic/csrf/token").then((res) => {
        this.submit("decoration/member/order/supplement", 2, res.csrf_token);
      });
    },
    // 提交
    submit(apiUrl, type, csrf_token) {
      let business_license_end = false;
      let id_card_image_front_end = false;
      let id_card_image_back_end = false;
      let house_using_thumbs_end = false;
      let house_scene_thumbs_end = false;
      let house_drawing_thumbs_end = false;
      let contract_thumbs_end = false;
      let house_number_thumbs_end = false;
      let business_license = []; //营业执照fileList4
      let id_card_image_front = []; //备注：法人证件图片正面fileList5
      let id_card_image_back = []; //备注：法人证件图片反面fileList6
      let house_using_thumbs = []; //备注：使用权fileList1
      let house_scene_thumbs = []; //备注：装修现场fileList7
      let house_drawing_thumbs = []; //备注：装饰图纸fileList2
      let contract_thumbs = []; //备注：装饰合同fileList3
      let house_number_thumbs = []; //备注：装饰合同fileList8
      this.fileList1.forEach((item, index) => {
        if (item.url) {
          house_using_thumbs.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          house_using_thumbs_end = true;
          return;
        }
      });
      this.fileList2.forEach((item, index) => {
        if (item.url) {
          house_drawing_thumbs.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          house_drawing_thumbs_end = true;
          return;
        }
      });
      this.fileList3.forEach((item, index) => {
        if (item.url) {
          contract_thumbs.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          contract_thumbs_end = true;
          return;
        }
      });
      this.fileList4.forEach((item, index) => {
        if (item.url) {
          business_license.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          business_license_end = true;
          return;
        }
      });
      //   人面像
      this.fileList5.forEach((item, index) => {
        if (item.url) {
          id_card_image_front.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          id_card_image_front_end = true;
          return;
        }
      });
      //   非人面像
      this.fileList6.forEach((item, index) => {
        if (item.url) {
          id_card_image_back.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          id_card_image_back_end = true;
          return;
        }
      });
      //   装修现场
      this.fileList7.forEach((item, index) => {
        if (item.url) {
          house_scene_thumbs.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          house_scene_thumbs_end = true;
          return;
        }
      });
      //   门牌号
      this.fileList8.forEach((item, index) => {
        if (item.url) {
          house_number_thumbs.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          house_number_thumbs_end = true;
          return;
        }
      });
      if (
        business_license_end ||
        id_card_image_front_end ||
        id_card_image_back_end ||
        house_using_thumbs_end ||
        house_scene_thumbs_end ||
        house_drawing_thumbs_end ||
        contract_thumbs_end ||
        house_number_thumbs_end
      ) {
        return;
      }
      this.$api
        .post(apiUrl, {
          order_id: this.id,
          csrf_token: csrf_token,
          space_type: this.space_type, //类型：Number  可有字段  备注：场地类型（住宅-4；企业-3）
          company_name: this.company_name, //类型：String  可有字段  备注：企业名称
          credit_code: this.credit_code, //类型：String  可有字段  备注：统一社会信用代码
          business_license: business_license, //类型：Array  可有字段  备注：营业执照
          id_card_type: this.id_card_type, //类型：Number  可有字段  备注：法人证件类型
          id_card_number: this.id_card_number, //类型：String  可有字段  备注：法人证件号码
          legal_person: this.legal_person, //类型：String  必有字段  备注：法人姓名
          id_card_image_front: id_card_image_front, //类型：Array  可有字段  备注：法人证件图片（正面）
          id_card_image_back: id_card_image_back, //类型：Array  可有字段  备注：法人证件图片（反面）
          area: this.area, //类型：Number  可有字段  备注：装饰面积
          total_amount: this.total_amount, //类型：Number  可有字段  备注：装饰总价
          region: {
            //类型：Object  可有字段  备注：装饰地址
            province_id: this.region.province_id, //类型：Number  必有字段  备注：省编号
            city_id: this.region.city_id, //类型：Number  必有字段  备注：市编码
          },
          province_city_area: this.province_city_area, //类型：String  可有字段  备注：省市地址
          address: this.address, //类型：String  可有字段  备注：具体地址
          house_type: this.house_type, //类型：Number  可有字段  备注：房屋类型
          house_using_thumbs: house_using_thumbs, //类型：Array  可有字段  备注：使用权
          house_scene_thumbs: house_scene_thumbs, //类型：Array  可有字段  备注：装修现场
          house_drawing_thumbs: house_drawing_thumbs, //类型：Array  可有字段  备注：装饰图纸
          contract_thumbs: contract_thumbs, //类型：Array  可有字段  备注：装饰合同
          amount: this.amount, //类型：Number  可有字段  备注：申请数额
          license_validity_time_type: this.license_validity_time_type, //类型：Number  必有字段  备注：营业执照有效期类型，默认 1
          license_validity_time:
            this.license_validity_time == "长期有效"
              ? ""
              : this.license_validity_time.replace(new RegExp("/", "g"), "-"), //类型：String  必有字段  备注：营业执照有效时间
          id_card_validity_time_type: this.id_card_validity_time_type, //类型：String  必有字段  备注：法人证件照有效期类型，默认 1
          id_card_validity_time:
            this.id_card_validity_time == "长期有效"
              ? ""
              : this.id_card_validity_time.replace(new RegExp("/", "g"), "-"), //类型：String  必有字段  备注：法人证件有效时间
          house_number_thumbs: house_number_thumbs,
        })
        .then((res) => {
          if (type == 1) {
            this.$toast("保存成功");
          } else if (type == 2) {
            this.getOrderData();
            this.$emit("nextStep");
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.secondOut {
  //   margin: 12px 16px;
  //   已完成
  .complete {
    padding-bottom: 43px;
    margin: 12px 16px;
    .completeContent {
      //   background-color: #ffffff;
      border-radius: 16px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      position: relative;
      .completeTitle {
        background-color: #ffffff;
        padding: 31px 24px 0px;
        h3 {
          display: inline-block;
          font-size: 16px;
          font-weight: 700;
          color: #333333;
          border-bottom: 5px solid #d2c3ff;
          margin: 0 0 6px;
          height: 16px;
          align-self: flex-start;
        }
      }

      .completeItem {
        // margin: 12px 4px 0;
        background-color: #ffffff;
        padding: 12px 28px 0;
        display: flex;
        justify-content: space-between;
        font-size: 15px;
        position: relative;
        p {
          color: #999999;
          flex-shrink: 0;
          margin-right: 16px;
          line-height: 21px;
        }
        span {
          color: #333333;
          text-align: right;
          word-break: break-all;
          line-height: 21px;
        }
        img {
          width: 72px;
          height: 48px;
          border-radius: 4px;
          border: 1px solid #f0f1ff;
          object-fit: cover;
        }
        div {
          position: absolute;
          width: 72px;
          height: 20px;
          right: 28px;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.2);
          border-radius: 0px 0px 4px 4px;
          font-size: 12px;
          font-weight: 600;
          color: #ffffff;
          line-height: 20px;
          text-align: center;
        }
      }
      .completeTip {
        background-color: #ffffff;
        padding: 15px 28px 7px;
        display: flex;
        justify-content: flex-end;
        position: relative;
        span {
          background: #f5f6ff;
          border-radius: 6px;
          font-size: 12px;
          color: #666666;
          line-height: 17px;
          padding: 6px 8px;
        }
        img {
          width: 17px;
          position: absolute;
          top: 7px;
          right: 42px;
        }
      }
      .completeImg {
        > div {
          margin-top: 1px;
          padding: 24px 28px;
          // border: 1px solid  red;
          background-color: #ffffff;
          p {
            font-size: 14px;
            color: #999999;
            margin-bottom: 3px;
          }
          > div {
            display: flex;
            margin-top: 9px;
            flex-wrap: wrap;
            justify-content: space-between;
            div {
              width: 18.7%;
              height: 54px;
              border-radius: 4px;
              border: 1px solid #f0f1ff;
              margin-top: 3px;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .kb {
              width: 18.7%;
            }
          }
        }
      }
      .bq {
        width: 68px;
        height: 68px;
        position: absolute;
        top: 7px;
        right: 15px;
      }
      .notdata {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        padding: 32px 0 30px;
        img {
          width: 101px;
          height: 85px;
        }
        p {
          font-size: 13px;
          color: #999999;
          margin-top: 7px;
        }
      }
    }
  }
  //   驳回原因
  .rejectReason {
    padding: 10px 16px;
    background-color: #ffdbc6;
    color: #ff7e31;
    p {
      font-size: 14px;
      margin-right: 10px;
      // border: 1px solid red;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      white-space: normal;
      word-break: break-all;
      word-wrap: break-word;
      text-align: justify;
      line-height: 24px;
    }
    .unfold {
      -webkit-line-clamp: 99;
    }
    .tipMore {
      display: flex;
      // justify-content: flex-end;
      span {
        font-size: 14px;
        display: flex;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
  //   未完成
  .uncomplete {
    padding-bottom: 169px;
    margin: 12px 16px;
    .uncompleteTop {
      background-color: #ffffff;
      border-radius: 16px 16px 0 0;
      padding: 20px 21px 40px;
      h3 {
        display: inline-block;
        font-size: 20px;
        font-weight: 700;
        color: #333333;
        border-bottom: 5px solid #d2c3ff;
        margin: 0 0 16px;
        height: 20px;
      }
      .placeType {
        //   border: 1px solid red;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 28px;
        p {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          margin: 0 0 0 6px;
        }
        > div {
          display: flex;
          align-items: center;
          div {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            padding: 6px 12px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #f0f1ff;
            position: relative;
            img {
              width: 12px;
              height: 12px;
              position: absolute;
              right: -1px;
              bottom: -1px;
            }
          }
          div:last-child {
            margin-left: 16px;
          }
          .checkedType {
            color: #5853e9;
            background: #f7f8ff;
            border: 1px solid #5853e9;
          }
        }
      }
      .itemImg {
        margin-top: 16px;
        > div {
          display: flex;
          p {
            font-size: 14px;
            color: #666666;
            margin-left: 16px;
            margin: 0 6px 0 16px;
            display: flex;
            flex-direction: column;
            span {
              font-size: 11px;
              font-weight: 400;
              color: #666666;
              line-height: 11px;
            }
          }
          .itemImgUplod {
            margin-left: 6px;
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
              width: 110px;
              height: 76px;
            }
            ::v-deep .box {
              height: 76px;
            }
            ::v-deep .van-uploader__preview {
              margin: 0;
            }
            ::v-deep .van-uploader__preview-image,
            ::v-deep .van-uploader__file {
              width: 110px;
              height: 76px;
              border-radius: 4px;
            }
            span {
              font-size: 12px;
              color: #999999;
              margin-top: 4px;
            }
          }
        }
      }
      .yyzz {
        p {
          margin: 0 6px 0 6px !important;
        }
      }
    }
    // 公共图片上传
    .imgUplod {
      margin: 1px 0 0;
      background: #ffffff;
      padding: 24px 14px 32px;
      .imgUplodTop {
        display: flex;
        p {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          flex-shrink: 0;
        }
        span {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          margin-left: 10px;
        }
      }
      .imgUplodBtm {
        display: flex;
        margin-top: 16px;
        img {
          width: 60px;
          height: 60px;
        }
        ::v-deep .van-uploader__preview {
          margin: 0 3px 4px 0;
        }
        ::v-deep .van-uploader__preview-image,
        ::v-deep .van-uploader__file {
          width: 60px;
          height: 60px;
          border-radius: 4px;
        }
        .preview-cover {
          width: 100%;
          height: 100%;
          overflow: hidden;
          img {
            height: 100%;
            width: auto;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      .pdfTip {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 10px 0 0;
        span {
          font-size: 11px;
          color: #5853e9;
          text-decoration: underline;
        }
      }
    }
    .imgUplod:last-child {
      border-radius: 0 0 16px 16px;
    }
    .btmSubmit {
      width: 100%;
      position: fixed;
      left: 0;
      bottom: 0;
      .btmSubmitTop {
        display: flex;
        padding: 15px 16px 12px;
        background-color: #f5f6ff;
        img {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
        p {
          font-size: 13px;
          font-weight: 400;
          color: #999999;
          span {
            color: #5853e9;
          }
        }
      }
      .btmSubmitBtm {
        box-shadow: inset 0px 1px 0px 0px #f7f8fc;
        height: 46px;
        // width: 100%;
        background-color: #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2px 16px 35px;
        span {
          font-size: 15px;
          font-weight: 500;
          color: #666666;
          margin: 0 30px 0 14px;
        }
        button {
          flex: 1;
          background-color: rgba(88, 83, 233, 0.4);
          border-radius: 25px;
          height: 46px;
          text-align: center;
          text-align: 46px;
          font-size: 16px;
          font-weight: 500;
          border: none;
          color: rgba(255, 255, 255, 0.7);
        }
        .checkedBtn {
          background-color: rgba(88, 83, 233, 1);
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    //
    .item {
      margin-top: 16px;
      border-radius: 6px;
      overflow: hidden;
      .itemLable {
        padding: 7px 16px;
        display: flex;
        align-items: center;
        background-color: #f7f8ff;
        p {
          font-size: 14px;
          color: #646566;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          line-height: 16px;
          span {
            font-size: 11px;
            font-weight: 400;
            color: #666666;
            // margin: 0 0 0 -10px;
            line-height: 11px;
          }
        }
        ::v-deep .van-cell {
          padding: 0 0 0 12px;
        }
      }

      .van-cell {
        background-color: #f7f8ff;
        padding: 8.5px 16px;
      }
      ::v-deep .van-field__label {
        width: auto;
      }
      ::v-deep .van-field__body {
        input::placeholder,
        textarea::placeholder {
          color: #cacde0;
          font-weight: normal;
        }
        input,
        textarea {
          color: #333333;
          font-weight: bold;
        }
      }
    }
    .itemTip {
      background: #f7f8ff;
      border-radius: 6px;
      margin-top: 12px;
      padding: 8px 16px 1px;
      div {
        display: flex;
        font-size: 13px;
        color: #666666;
        margin-bottom: 8px;
        > span {
          flex-shrink: 0;
          margin-right: 5px;
        }
        p {
          span {
            font-size: 11px;
            color: #999999;
            margin-left: 5px;
          }
        }
      }
    }
    .selectItem {
      margin-top: 16px;
      border-radius: 6px;
      overflow: hidden;
      > div {
        padding: 0px 16px;
        height: 41px;
        font-size: 14px;
        color: #646566;
        display: flex;
        align-items: center;
        background-color: #f7f8ff;
        p {
          display: flex;
          flex-direction: column;
          span {
            font-size: 11px;
            font-weight: 400;
            color: #666666;
            margin: 0;
            line-height: 11px;
          }
        }
        span {
          flex: 1;
          margin: 0 12px;
          font-weight: bold;
        }
        img {
          width: 16px;
          height: 16px;
        }
      }
    }
    .addressItem {
      .itemLable {
        align-items: flex-start;
        ::v-deep .van-cell {
          padding: 0 0 3px 12px;
        }
      }
    }
  }
  .sheetContent {
    .selectType {
      max-height: 500px;
      margin: 12px 0 55px;
      p {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        padding: 12px 0;
        text-align: center;
      }
      .check {
        color: #5853e9;
      }
    }
    .selectValidity {
      height: 400px;
      display: flex;
      flex-direction: column;
      > div {
        overflow: hidden;
        flex: 1;
      }
      > p {
        height: 60px;
        flex-shrink: 0;
        border-top: 1px solid #f0f1ff;
        font-size: 16px;
        font-weight: bold;
        color: #5853e9;
        text-align: center;
        display: flex;
        justify-content: center;
        span {
          margin: 10px 0;
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
  .van-action-sheet__header {
    color: #333333;
    font-weight: bold;
    font-size: 16px;
  }
  ::v-deep .van-image-preview__index {
    width: 100%;
  }
  .imagePreview {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 24px;
    span {
      background-color: rgba(255, 255, 255, 0.2);
      padding: 4px 12px;
      border-radius: 15px;
    }
    span:first-child,
    span:last-child {
      padding: 4px 8px;
    }
  }
  .imagePreviewTip {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.48);
    position: fixed;
    height: 50px;
    margin-top: 450px;
    span {
      margin-left: 12px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.8);
      color: #424242;
      font-size: 12px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        margin: 0 8px;
        font-size: 12px;
        color: #ffffff;
        line-height: 17px;
      }
      div {
        margin: 0 16px 0 13px;
        font-size: 14px;
      }
    }
  }
  .noShowTip {
    width: 40px;
    height: 32px;
    border-radius: 1px 100px 100px 1px;
  }
  .van-action-sheet__description {
    padding-bottom: 0;
  }
  .pdfPopupTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 16px;
      color: #999999;
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
  .stepper-warpper {
    height: 28px;
    position: relative;
    background-color: #fff;
    margin-top: 10px;
    .van-stepper {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .percent {
      position: absolute;
      height: 28px;
      line-height: 28px;
      width: 40px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      background-color: #f2f3f5;
      font-size: 13px;
    }
  }
  .pdfTipContent {
    margin: 0 12px 12px;
    div {
      margin: 11px 18px;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
    }
    img {
      width: 100%;
    }
  }
}
.allComplete {
  margin: 0px;
  .complete {
    padding-bottom: 0;
    margin: 0;
    .completeContent {
      border-radius: 0;
    }
  }
}
</style>
